import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "humanResourceFormIsOpen", false);
        Vue.set(state, "humanResourceGridIsOpen", true);
        Vue.set(state, "qualificationFormIsOpen", false);
        Vue.set(state, "qualificationGridIsOpen", true);
        Vue.set(state, "languageFormIsOpen", false);
        Vue.set(state, "languageGridIsOpen", true);
        Vue.set(state, "feeFormIsOpen", false);
        Vue.set(state, "feeGridIsOpen", true);
    },
    setHumanResourceFormOpen(state) {
        state.humanResourceFormIsOpen = true;
        state.humanResourceGridIsOpen = false;
    },
    setHumanResourceFormClose(state) {
        state.humanResourceFormIsOpen = false;
        state.humanResourceGridIsOpen = true;
    },

    setQualificationFormOpen(state) {
        state.qualificationFormIsOpen = true;
        state.qualificationGridIsOpen = false;
    },
    setQualificationFormClose(state) {
        state.qualificationFormIsOpen = false;
        state.qualificationGridIsOpen = true;
    },

    setLanguageFormOpen(state) {
        state.languageFormIsOpen = true;
        state.languageGridIsOpen = false;
    },
    setLanguageFormClose(state) {
        state.languageFormIsOpen = false;
        state.languageGridIsOpen = true;
    },

    setFeeFormOpen(state) {
        state.feeFormIsOpen = true;
        state.feeGridIsOpen = false;
    },
    setFeeFormClose(state) {
        state.feeFormIsOpen = false;
        state.feeGridIsOpen = true;
    }
}
